import BreadcrumbDropdownPicker, {
  type BreadcrumbDropdownPickerOption,
} from "components/Breadcrumbs/BreadcrumbDropdownPicker";
import { useAppSelector } from "redux/hooks";
import { selectDuplicateEntities, selectDuplicateRules } from "redux/slices/lensEditor";
import {
  AutoAwesome,
  Code,
  Label,
  NoteAlt,
  Person2,
  QueryStats,
  RuleFolder,
  Settings,
  Warning,
  WorkHistory,
} from "@mui/icons-material";
import { AppRoutes } from "AppRoutes";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";

interface LensEditorSubnavBreadcrumbProps {
  route: string;
  routeTitle: string;
}
export const LensEditorSubnavBreadcrumb = (props: LensEditorSubnavBreadcrumbProps) => {
  const { lensId } = useParamNumbers(["lensId"]);
  const duplicateRules = useAppSelector(selectDuplicateRules);
  const duplicateEntities = useAppSelector(selectDuplicateEntities);

  const dupeCount = duplicateEntities.length + duplicateRules.length;

  const options: BreadcrumbDropdownPickerOption[] = [
    {
      title: "Rules",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/rules`,
      icon: <RuleFolder />,
      uniqueId: "rules",
    },
    {
      title: "Profile",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/profile`,
      icon: <Person2 />,
      uniqueId: "profile",
    },
    {
      title: "Case Properties",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/case-properties`,
      icon: <NoteAlt />,
      uniqueId: "case_properties",
    },
    {
      title: "Scripts",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/scripts`,
      icon: <Code />,
      uniqueId: "scripts",
    },
    {
      title: "AI Review",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/ai`,
      icon: <AutoAwesome />,
      uniqueId: "ai_review",
    },
    {
      title: "Page Labels",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/page-labels`,
      icon: <Label />,
      uniqueId: "page_labels",
    },
    {
      title: "Document Properties",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/document-properties`,
      icon: <NoteAlt />,
      uniqueId: "document_properties",
    },
    {
      title: "Duplicate Lens Rules (" + dupeCount + ")",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/duplicates`,
      icon: <Warning />,
      uniqueId: "duplicates",
    },
    {
      title: "Lens Run Status",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/stats`,
      icon: <QueryStats />,
      uniqueId: "stats",
    },
    {
      title: "Chronology",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/chronology`,
      icon: <WorkHistory />,
      uniqueId: "chronology",
    },
    {
      title: "Tags",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/tags`,
      icon: <Label />,
      uniqueId: "tags",
    },
    {
      title: "Settings",
      route: `${AppRoutes.lensEditorDetailBuilder(lensId)}/settings`,
      icon: <Settings />,
      uniqueId: "settings",
    },
  ];

  return (
    <BreadcrumbDropdownPicker
      pendoId="breadcrumb-lens-editor-subnav"
      search={false}
      label={props.routeTitle}
      noResultsText={undefined}
      currentRoute={`${AppRoutes.lensEditorDetailBuilder(lensId)}/${props.route}`}
      options={options}
      PopoverSX={{
        ".options-container": {
          maxHeight: "none",
        },
      }}
    />
  );
};
